module.exports = __webpack_public_path__ + "static/media/annaluke_engagement-136-min.a6815fc6.jpg";